"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillAddressToJSON = exports.BillAddressFromJSONTyped = exports.BillAddressFromJSON = exports.instanceOfBillAddress = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the BillAddress interface.
 */
function instanceOfBillAddress(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBillAddress = instanceOfBillAddress;
function BillAddressFromJSON(json) {
    return BillAddressFromJSONTyped(json, false);
}
exports.BillAddressFromJSON = BillAddressFromJSON;
function BillAddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'street': !(0, runtime_1.exists)(json, 'street') ? undefined : json['street'],
        'region': !(0, runtime_1.exists)(json, 'region') ? undefined : json['region'],
        'postalCode': !(0, runtime_1.exists)(json, 'postal_code') ? undefined : json['postal_code'],
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
    };
}
exports.BillAddressFromJSONTyped = BillAddressFromJSONTyped;
function BillAddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'street': value.street,
        'region': value.region,
        'postal_code': value.postalCode,
        'country': value.country,
    };
}
exports.BillAddressToJSON = BillAddressToJSON;
